import React from "react";
import { VendorCloseSvg } from "../../../components/CommonSvg";

const MemberFilterCard = ({
    stateList,
    cityList,
    countyList,
    stateName,
    cityName,
    countyName,
    onStateChange,
    onCityChange,
    onCountyChange,
    onClear,
    onClose,
}) => (
    <div className="vp-fcard">
        <div className="vp-fcard-head">
            <span>Filter</span>
            <div className="vp-fcard-actions">
                <button type="button" className="vp-fclear" onClick={onClear}>
                    Clear all
                </button>
                <button
                    type="button"
                    className="vp-fclose"
                    title="Close filter"
                    onClick={onClose}
                >
                    <VendorCloseSvg size={15} />
                </button>
            </div>
        </div>

        <div className="vp-fcard-grid">
            <label className="vp-ffield">
                <span>State</span>
                <select
                    value={stateName}
                    onChange={(e) => onStateChange(e.target.value)}
                >
                    <option value="">All states</option>
                    {stateList.map((state) => (
                        <option value={state.stateName} key={state.id}>
                            {state.stateName}
                        </option>
                    ))}
                </select>
            </label>

            <label className="vp-ffield">
                <span>City</span>
                <select value={cityName} onChange={(e) => onCityChange(e.target.value)}>
                    <option value="">All cities</option>
                    {cityList.map((city) => (
                        <option value={city.cityName} key={city.id}>
                            {city.cityName}
                        </option>
                    ))}
                </select>
            </label>

            <label className="vp-ffield">
                <span>County</span>
                <select
                    value={countyName}
                    onChange={(e) => onCountyChange(e.target.value)}
                >
                    <option value="">All counties</option>
                    {countyList.map((county) => (
                        <option value={county.countyName} key={county.id}>
                            {county.countyName}
                        </option>
                    ))}
                </select>
            </label>
        </div>
    </div>
);

export default MemberFilterCard;
